import { useState } from 'react'

type UseRequestTaskResult = {
  run: (taskId: string, ...param: any) => Promise<any>
  taskList: Array<string>
}

/**
 * 请求队列
 * @param request 接口请求函数 Promise
 * @return {run: 接口请函执行求数， taskList: 正在执行的任务}
 */
export function useRequestTask(request: any): UseRequestTaskResult {
  const [taskList, setTaskList] = useState<Array<string>>([])

  const run = async (taskId: string, ...params: any) => {
    try {
      setTaskList(val => val.concat(taskId))
      let result = await request(...params)
      setTaskList(val => val.filter(key => key != taskId))
      return Promise.resolve(result)
    } catch (e) {
      setTaskList(val => val.filter(key => key != taskId))
      return Promise.reject(e)
    }
  }

  return {
    run: run,
    taskList,
  }
}
